import PropTypes from "prop-types";
import React from "react";
import { ImageComp } from "../Image/image";

const BannerImage = ({ bannerImgUrl }) => {
  return (
    <ImageComp
      url={bannerImgUrl}
      className="banner-image"
    />
  );
};

BannerImage.propTypes = {
  bannerImgUrl: PropTypes.string,
};
export default BannerImage;
